import { DEFAULT_MARKER_Z_INDEX } from './EventMarker/constants';

export const TIMELINE_PADDING = 24;

export const PROGRESS_HANDLE_Z_INDEX = DEFAULT_MARKER_Z_INDEX + 1;
